export const getDictionaryConstraintUuidKey = (ids: string[]) => ids.join('/');
